import Agreement from "@/pages/common/agreement/Agreement"
import { lazy, Suspense } from "react"

const IdentityOCR = lazy(() => import("./identityOCR/IdentityOCR"))
const IdentityOCRResult = lazy(() => import("./identityOCRResult/IdentityOCRResult"))

const InformationForm = lazy(() => import("./informationForm/InformationForm"))

const InstallmentCalc = lazy(() => import("./installmentCalc/InstallmentCalc"))

const BankAccount = lazy(() => import("./bankAccount/BankAccount"))

const Sign = lazy(() => import("./sign/Sign"))
const SignResultLoading = lazy(() => import("./signResultLoading/SignResultLoading"))

const SignRepaymentPlan = lazy(() => import("./signRepaymentPlan/SignRepaymentPlan"))
const SignAgreement = lazy(() => import("./signAgreement/signAgreement"))

const Repayment = lazy(() => import("./repayment/Repayment"))
const Cashier = lazy(() => import("./cashier/Cashier")) // 还款收银台
const RepaymentBillCalc = lazy(() => import("./repaymentCalc/RepaymentBillCalc")) // 账单还款试算详情
const RepaymentAllCalc = lazy(() => import("./repaymentCalc/RepaymentAllCalc")) // 提前结清试算详情

const AddBankAccount = lazy(() => import("./addBankAccount/AddBankAccount"))


const router = [
  {
    path: "identityOCR", // 身份证OCR
    element: (
      <Suspense fallback={<div>Loading..</div>}>
        <IdentityOCR />
      </Suspense>
    )
  },
  {
    path: "identityOCRResult", // 身份证OCR结果
    element: (
      <Suspense fallback={<div>Loading..</div>}>
        <IdentityOCRResult />
      </Suspense>
    )
  },
  {
    path: "informationForm", // 个人信息、教育信息、常用联系人
    element: (
      <Suspense fallback={<div>Loading..</div>}>
        <InformationForm />
      </Suspense>
    )
  },
  {
    path: "installmentCalc", // 分期试算
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <InstallmentCalc />
      </Suspense>
    ),
  },
  {
    path: "sign", // 签约
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Sign />
      </Suspense>
    ),
  },
  {
    path: "bankAccount", // 银行卡管理
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <BankAccount />
      </Suspense>
    ),
  },
  {
    path: "signRepaymentPlan", // 还款计划详情
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SignRepaymentPlan />
      </Suspense>
    ),
  }, 
  {
    path: "signAgreement", // 签约合同
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SignAgreement />
      </Suspense>
    ),
  },
  {
    path: "signResultLoading", // 签约结果等待
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SignResultLoading />
      </Suspense>
    ),
  },
  {
    path: "repayment", // 还款
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Repayment />
      </Suspense>
    ),
  },
  {
    path: "cashier", // 还款收银台
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Cashier />
      </Suspense>
    ),
  },
  {
    path: "repaymentBillCalc", // 账单还款试算详情
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <RepaymentBillCalc />
      </Suspense>
    ),
  },
  {
    path: "repaymentAllCalc", // 提前结清试算详情
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <RepaymentAllCalc />
      </Suspense>
    ),
  },
  {
    path: "addBankAccount", // 添加银行卡
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <AddBankAccount />
      </Suspense>
    ),
  },
]

export default router